module.exports = __webpack_public_path__ + "static/media/it-support.8e618395.png";